// CONST
import ROUTES from "./routesContants"

// Pages
import * as generalPages from "./page-groups/general_page"
import * as participants from "./page-groups/participant"

const routesDef = [
  {
    path: ROUTES.HOMEPAGE,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <generalPages.Homepage />,
  },
  {
    path: ROUTES.DENIED,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <generalPages.PermissionDenied />,
  },
  {
    path: ROUTES.PARTICIPANT_TELERECOVERY_SERVICES + "/:type",
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.TelerecoveryServices />,
  },

  {
    path: ROUTES.PARTICIPANT_TELERECOVERY_SERVICES + "/:type/:peerId",
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.TelerecoveryServices />,
  },
  {
    path: ROUTES.FORM_VIEW_MODE,
    requireAdmin: false,
    leastPrivilege: 100,
    userGroupType: 0,
    element: <generalPages.FormViewMode />,
  },
  {
    path: ROUTES.PARTICIPANT_CUSTOM_DATA_FORMS,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.CustomDataForms />,
  },
  {
    path: ROUTES.PARTICIPANT_ASSESSMENTS,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.Assessments />,
  },
  {
    path: ROUTES.PARTICIPANT_RECOVERY_PLAN,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.RecoveryPlan />,
  },
  {
    path: ROUTES.PARTICIPANT_RECOVERY_PLAN_VIEW,
    requireAdmin: false,
    leastPrivilege: 100,
    userGroupType: 0,
    element: <participants.RecoveryPlanView />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGEMENTS,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.Engagements />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGED_SERVICES,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.EngagedServices />,
  },
  {
    path: ROUTES.PARTICIPANT_SERVICE_EPISODES,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.ServiceEpisodes />,
  },
  {
    path: ROUTES.PARTICIPANT_REFERRALS_DETAIL,
    requireAdmin: true,
    leastPrivilege: "100",
    element: <participants.ReferralsDetail />,
  },
  {
    path: ROUTES.PARTICIPANT_REFERRALS,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.Referrals />,
  },
  {
    path: ROUTES.PARTICIPANT_CUSTOM_FORMS,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.CustomsFormsIndex />,
  },
  {
    path: ROUTES.PARTICIPANT_DOCUMENTS,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <participants.Documents />,
  },
  {
    path: ROUTES.PREFERENCES_ACCOUNT,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <generalPages.PreferencePage />,
  },
  {
    path: ROUTES.PREFERENCES_PROFILE,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <generalPages.PreferencePage />,
  },
  {
    path: ROUTES.PREFERENCES_NOTIFICATIONS,
    requireAdmin: false,
    leastPrivilege: 100,
    element: <generalPages.PreferencePage />,
  },
]

export default routesDef
